export default "__VITE_ASSET__J3p7kQXZ__"